import { Pass } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useCreatePassQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/passes`
	return useLazyQuery<Pass, void>(url, "POST")
}
